(function () {
  const WAIT_MS = 1000;
  const timers = new WeakMap();

  function getButtonTextNode(btn) {
    // Пытаемся найти внутренний текстовый элемент темы
    return (
      btn.querySelector('[data-add-to-cart-text]') ||
      btn.querySelector('.button__text') ||
      btn.querySelector('.btn__text') ||
      btn.querySelector('span') ||
      btn
    );
  }

  function setWaitingState(btn, waiting) {
    const textEl = getButtonTextNode(btn);

    if (waiting) {
      if (!btn.dataset.qtySyncOriginalText) {
        btn.dataset.qtySyncOriginalText = (textEl.textContent || '').trim();
      }
      btn.disabled = true;
      btn.setAttribute('aria-disabled', 'true');
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('qty-sync-waiting');

      const waitText =
        btn.dataset.qtyWaitText ||
        btn.closest('product-form-component')?.dataset.qtyWaitText ||
        btn.closest('form')?.dataset.qtyWaitText ||
        'Please wait...';
      textEl.textContent = waitText;
      return;
    }

    // restore
    btn.classList.remove('qty-sync-waiting');
    btn.removeAttribute('aria-busy');

    const original = btn.dataset.qtySyncOriginalText;
    if (original) {
      textEl.textContent = original;
    }

    // Включаем кнопку обратно только если форма не в другом loading-состоянии темы
    btn.disabled = false;
    btn.setAttribute('aria-disabled', 'false');
  }

  function armCooldown(qtyField, addBtn) {
    if (!qtyField || !addBtn) return;

    // сбрасываем предыдущий таймер
    const prev = timers.get(addBtn);
    if (prev) clearTimeout(prev);

    setWaitingState(addBtn, true);

    const t = setTimeout(() => {
      setWaitingState(addBtn, false);
      timers.delete(addBtn);
    }, WAIT_MS);

    timers.set(addBtn, t);
  }

  function initOneProductForm(scope) {
    const form =
      scope.matches?.('form') ? scope : scope.querySelector?.('form');

    if (!form || form.dataset.qtySyncGuardInit === '1') return;

    // Похоже на product form?
    const hasVariant = !!form.querySelector('input[name="id"]');
    const addBtn = form.querySelector(
      'button[type="submit"], button[name="add"], [type="submit"][name="add"]'
    );
    if (!hasVariant || !addBtn) return;

    const qtyField =
      form.querySelector('select[name="quantity"]') ||
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('input[type="number"]');

    if (!qtyField) return;

    form.dataset.qtySyncGuardInit = '1';

    // При смене количества — блокируем кнопку на 1 сек
    qtyField.addEventListener('change', () => armCooldown(qtyField, addBtn), true);
    qtyField.addEventListener('input', () => armCooldown(qtyField, addBtn), true);

    // Если пользователь очень быстро кликает и somehow событие ещё не успело — защитимся на mousedown
    addBtn.addEventListener('mousedown', () => {
      // Если кнопка уже в waiting state, клик не нужен
      if (addBtn.classList.contains('qty-sync-waiting')) return;
    }, true);
  }

  function init(root = document) {
    // Твоя тема использует product-form-component
    root.querySelectorAll('product-form-component').forEach((pfc) => initOneProductForm(pfc));

    // Фолбэк для тем без product-form-component
    root.querySelectorAll('form').forEach((form) => initOneProductForm(form));
  }

  document.addEventListener('DOMContentLoaded', () => init());

  // Для Theme Editor / динамических перерисовок секций
  document.addEventListener('shopify:section:load', (e) => init(e.target || document));
})();